<template>
  <div class="input">
    <div class="input-label">場所</div>
    <div class="input-group">
      <div class="input-label_before">緯度</div>
      <input type="text" class="input-text" v-model="lat">
      <div class="input-label_before">経度</div>
      <input type="text" class="input-text" v-model="lng">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    lat: {
      get: function () {
        return this.$store.state.tourism.lat
      },

      set: function (value) {
        this.$store.commit(
          'tourism/setLat',
          value
        )
      }
    },

    lng: {
      get: function () {
        return this.$store.state.tourism.lng
      },

      set: function (value) {
        this.$store.commit(
          'tourism/setLng',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
